import {PERMISSIONS} from "../constants/AuthConstant";
import CryptoJS from "crypto-js";

const SECRET_KEY = "p4X!tH8@p7RzY#3R$m6Y&k2N%bL9*Jg3G"; // Strong secret key
let cachedPermissions = null;

// Function to decrypt and cache permissions
export const loadPermissions = () => {
    if (cachedPermissions) return cachedPermissions; // Return cached permissions if available

    try {
        const encryptedPermissions = localStorage.getItem(PERMISSIONS) || "";
        const bytes = CryptoJS.AES.decrypt(encryptedPermissions, SECRET_KEY);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

        cachedPermissions = decryptedText ? decryptedText : [];
        return cachedPermissions;
    } catch (error) {
        console.error("Failed to decrypt permissions:", error.message);
        cachedPermissions = [];
        return cachedPermissions;
    }
};

function CheckPermissions(permission) {
    if (!cachedPermissions) {
        loadPermissions();
    }

    if (typeof permission !== "string" || !permission) {
        console.warn("Invalid permission passed:", permission);
        return false;
    }

    if (permission === 'all_customer_permissions' || cachedPermissions.includes('all_customer_permissions')) {
        return cachedPermissions.includes(permission) || permission.includes("/customer/")
    } else if (permission === 'all_reseller_permissions' || cachedPermissions.includes('all_reseller_permissions')) {
        return cachedPermissions.includes(permission) || permission.includes("/reseller/")
    } else if (permission === 'all_advertiser_permissions' || cachedPermissions.includes('all_advertiser_permissions')) {
        return cachedPermissions.includes(permission) || permission.includes("/advertiser/")
    } else {
        return cachedPermissions.includes(permission) || cachedPermissions.includes("all_permissions");
    }
}

export default CheckPermissions;

export const ResetPermissions = () => {
    cachedPermissions = null;
};
